import EntryActionTypes from '../../constants/EntryActionTypes';

export const createDevice = (data) => ({
  type: EntryActionTypes.DEVICE_CREATE,
  payload: {
    data,
  },
});

export const updateDevice = (id, data) => ({
  type: EntryActionTypes.DEVICE_UPDATE,
  payload: {
    id,
    data,
  },
});

export const updateDeviceCommon = (id, data) => ({
  type: EntryActionTypes.DEVICE_COMMON_UPDATE,
  payload: {
    id,
    data,
  },
});

export const hideDevice = (id) => ({
  type: EntryActionTypes.DEVICE_HIDE,
  payload: {
    id,
  },
});

export const updateCurrentDevice = (data) => ({
  type: EntryActionTypes.CURRENT_DEVICE_UPDATE,
  payload: {
    data,
  },
});

export const moveDevice = (id, lineId, index = 0) => ({
  type: EntryActionTypes.DEVICE_MOVE,
  payload: {
    id,
    lineId,
    index,
  },
});

export const moveCurrentDevice = (lineId, index = 0) => ({
  type: EntryActionTypes.CURRENT_DEVICE_MOVE,
  payload: {
    lineId,
    index,
  },
});

export const transferDevice = (id, siteId, lineId, index = 0) => ({
  type: EntryActionTypes.DEVICE_TRANSFER,
  payload: {
    id,
    siteId,
    lineId,
    index,
  },
});

export const transferCurrentDevice = (siteId, lineId, index = 0) => ({
  type: EntryActionTypes.CURRENT_DEVICE_TRANSFER,
  payload: {
    siteId,
    lineId,
    index,
  },
});

export const deleteDevice = (id) => ({
  type: EntryActionTypes.DEVICE_DELETE,
  payload: {
    id,
  },
});

export const deleteCurrentDevice = () => ({
  type: EntryActionTypes.CURRENT_DEVICE_DELETE,
  payload: {},
});
